import { Outlet } from 'react-router-dom'

const TeamleadLayout: React.FC = () => <Outlet />

export default TeamleadLayout
